<div class="flex-hero-wrapper" [ngStyle]="{background: 'radial-gradient(circle, rgba(' + block.data.backgroundstart + ') 0%, rgba(' + block.data.backgroundend + ') 100%)'}">
    <div class="flex-hero-wrapper__content row">
        <div class="flex-hero-wrapper__column hero-text col-md-6">
            <img src="assets/img/flex/HeroLogo.png" class="flex-hero-wrapper__logo" alt="FLEXBeneifts">
            <h1 class="flex-hero-wrapper__header" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></h1>
            <p class="flex-hero-wrapper__text" [innerHTML]="block.data.subtitle"></p>
            <a href="{{block.data.link}}" class="btn btn-primary hero-wrapper__button" *ngIf="block.data.buttonText">{{block.data.buttonText}}</a>
        </div>
        <div class="flex-hero-wrapper__column col-md-6">
            <div class="flex-hero-image-wrapper">
                <div id="heroScene" class="hero-scene" data-relative-input="true">
                    <img src="./assets/img/flex/HeroBack.png" data-depth="2" class="flex-image-back" alt="" />
                    <img src="./assets/img/flex/HeroFront.png" data-depth="0.5" class="flex-image-front" alt="" />
                    <img src="{{block.data.image_url}}" data-depth="1" class="flex-image-middle" alt="" />
                </div>
            </div>
         </div>
    </div>
</div>


